<div class="box-view">
  <div class="box-header d-flex justify-content-between align-items-center">
    @if (title) {
      <h3>{{ title }}</h3>
    }

    @if (hasTabs()) {
      <div class="tabs">
        <ul class="nav nav-tabs">
          @for (tab of tabs; track tab; let i = $index) {
            <li class="nav-item">
              <a
                class="nav-link"
                [class.active]="i === activeTabIndex"
                (click)="selectTab(i)"
                href="javascript:void(0)">
                {{ tab }}
              </a>
            </li>
          }
        </ul>
      </div>
    }
  </div>

  <div class="box-content">
    <ng-content></ng-content>
  </div>
</div>